import {
  FULFILLMENT_TIMELINE_STEPS,
  resolveTimelineStepKey,
  getTimelineStepIndex,
  isTerminalTimelineStep,
  resolveTimelineDisplayStep,
} from '../../utils/fulfillmentTimeline';

import './FulfillmentTimeline.css';



function formatEventDate(iso) {

  if (!iso) return '';

  try {

    return new Date(iso).toLocaleDateString('es-AR', {

      day: 'numeric',

      month: 'short',

      hour: '2-digit',

      minute: '2-digit',

    });

  } catch {

    return '';

  }

}



const FulfillmentTimeline = ({

  fulfillmentStatus,

  shippingStatus,

  trackingNumber,

  events = [],

}) => {

  const activeKey = resolveTimelineStepKey({ shippingStatus, fulfillmentStatus });
  const activeIndex = getTimelineStepIndex(activeKey);
  const terminal = isTerminalTimelineStep(activeKey);
  const terminalStep = terminal ? resolveTimelineDisplayStep(activeKey) : null;

  const sortedEvents = [...(events || [])].sort(

    (a, b) => new Date(a.occurredAt) - new Date(b.occurredAt),

  );



  return (

    <div className="FT-wrap" aria-label="Seguimiento del envío">

      {terminal && terminalStep ? (
        <div className={`FT-terminal FT-terminal--${activeKey}`} role="status">
          <i className={`fas ${terminalStep.icon}`} aria-hidden="true" />
          <span>{terminalStep.label}</span>
        </div>
      ) : null}

      <div className="FT-steps">

        {FULFILLMENT_TIMELINE_STEPS.map((step, index) => {

          const done = index < activeIndex;

          const current = index === activeIndex;

          const state = done ? 'done' : current ? 'current' : 'upcoming';



          return (

            <div key={step.key} className={`FT-step FT-step--${state}`}>

              <div className="FT-step-marker" aria-hidden="true">

                {done ? (

                  <i className="fas fa-check" />

                ) : (

                  <i className={`fas ${step.icon}`} />

                )}

              </div>

              <div className="FT-step-label">{step.label}</div>

              {index < FULFILLMENT_TIMELINE_STEPS.length - 1 && (

                <div

                  className={`FT-step-line${done ? ' FT-step-line--done' : ''}`}

                  aria-hidden="true"

                />

              )}

            </div>

          );

        })}

      </div>



      {trackingNumber && (

        <div className="FT-tracking">

          <span className="FT-tracking-label">Nº de seguimiento</span>

          <code>{trackingNumber}</code>

        </div>

      )}



      {sortedEvents.length > 0 && (

        <ul className="FT-events" aria-label="Historial de eventos">

          {sortedEvents.map((ev) => (

            <li key={ev.id || `${ev.eventType}-${ev.occurredAt}`} className="FT-event">

              <time className="FT-event-time" dateTime={ev.occurredAt}>

                {formatEventDate(ev.occurredAt)}

              </time>

              <span className="FT-event-desc">{ev.description || ev.eventType}</span>

            </li>

          ))}

        </ul>

      )}

    </div>

  );

};



export default FulfillmentTimeline;


